export const BASE_URL = `${(window as any).config.apiBaseUrl}/v1`
export const DEFAULT_FETCH_OPTIONS = { headers: { accept: "application/json", "content-type": "application/json"}}